export const FONT_FAMILY_BRAND = "termina, sans-serif";
export const FONT_FAMILY_BODY = "inter-variable, sans-serif";
